import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { LocationListIdCell } from './location-list-id.cell';
import { LocationListIdHeader } from './location-list-id.header';

export const LocationListIdColumn: IdentifiedColumnDef<
  GatewayLocationModel,
  GatewayLocationModel['id']
> = {
  enableSorting: false,
  header: LocationListIdHeader,
  cell: LocationListIdCell,
};
